import { vaultRequest } from './request';
import { StripeEnv } from '../../util/enums';

const GET_SETUP_INTENT_CLIENT_SECRET = `mutation SetupIntentCreate($customerId: String, $stripeEnv: VaultStripeEnv) {
  client_secret: vaultSetupIntentCreate(
    customerId: $customerId
    stripeEnv: $stripeEnv
  )
}
`;

export const getSetupIntentSecretClient = async (setupIntentParams: {
  customerId: string;
  stripeEnv: StripeEnv;
}): Promise<string | null> => {
  const setupIntentRes = await vaultRequest(
    GET_SETUP_INTENT_CLIENT_SECRET,
    setupIntentParams,
  );
  const setupIntentData = await setupIntentRes.json();
  if (setupIntentData.errors) {
    throw new Error(setupIntentData.errors);
  }
  return setupIntentData.data.client_secret;
};
